const getAdminDashboardMetricsData = state => state?.adminDashboard?.adminDashboardMetrics

const selectors = {
  getAdminDashboardMetricsData,
}

export default selectors
